module.exports = __webpack_public_path__ + "img/Costa_Logo.a6f37207.png";